module.exports = __webpack_public_path__ + "static/media/loadingIcon.f49d6e59.svg";